import { PATHS } from "../../../packs/travel_book/avia_v3/utils/variables/api"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${PATHS.ADMIN.BASE}${PATHS.ADMIN.HOTELS}/${endpoint ? endpoint : ""}`

export const hotelsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHotels: builder.query({
      query: (params) => {
        const searchParams = new URLSearchParams()

        const defaults = {
          state_id: 0,
          region_ids: [],
          resort_id: 0,
          company_id: [],
          provider_id: [],
          market_id: [],
          star_ids: [],
          search: "",
          hotels_orphan: 0,
        }

        const { page = 1, ...restParams } = params ?? {}
        const merged = { ...defaults, ...restParams }
        const arrayFields = ["region_ids", "company_id", "provider_id", "market_id", "star_ids"]

        Object.entries(merged).forEach(([key, value]) => {
          if (arrayFields.includes(key)) {
            const arr = Array.isArray(value) ? value : [value]
            if (arr.length === 0) {
              searchParams.append(`hotel[${key}][]`, "")
            } else {
              arr.forEach((v) => searchParams.append(`hotel[${key}][]`, v))
            }
          } else {
            searchParams.append(`hotel[${key}]`, value ?? "")
          }
        })

        if (page > 1) {
          searchParams.append("page", page)
        }

        return {
          url: `${buildBundleUrl("")}?${searchParams.toString()}`,
          method: "GET",
        }
      },
    }),
  }),
})

export const { useLazyGetHotelsQuery } = hotelsService
